import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';

interface Pesquisador {
  id: number;
  nomeCompleto: string;
  cpf: string;
  email: string;
  telefone: string;
  endereco: string;
  pesquisadorBrasil: boolean;
  pesquisadorItalia: boolean;
  pesquisadorOutros: boolean;
  outrosPaises?: string;
}

@Component({
  selector: 'app-cadastro-pesquisador',
  templateUrl: './cadastro-pesquisador.component.html',
  styleUrls: ['./cadastro-pesquisador.component.scss']
})
export class CadastroPesquisadorComponent implements OnInit {
  cadastroForm: FormGroup;
  pesquisadores: any[] = [];
  pesquisadoresFiltrados: any[] = [];
  modalRef: NgbModalRef;
  outrosPaises: string = '';
  pesquisadorSelecionado: any;
  loading: boolean = false;

  // Propriedades para filtros
  filtroNome: string = '';
  filtroCpf: string = '';
  filtroPesquisador: string = '';

  // Máscaras para os campos
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService
  ) {
    this.cadastroForm = this.fb.group({
      id: [''],
      nomeCompleto: ['', Validators.required],
      cpf: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      endereco: ['', Validators.required],
      pesquisadorBrasil: [false],
      pesquisadorItalia: [false],
      pesquisadorOutros: [false],
      outrosPaises:['']
    });
  }

  ngOnInit() {
    this.carregarPesquisadores();
  }

  carregarPesquisadores() {
    this.loading = true;
    let url = API + "UsuarioPesquisador/UsuarioPesquisador";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.pesquisadores = response.data;
        this.pesquisadoresFiltrados = [...this.pesquisadores];
        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar pesquisadores:', error);
        this.loading = false;
      }
    });
  }

  aplicarFiltros() {
    this.pesquisadoresFiltrados = this.pesquisadores.filter(pesquisador => {
      const matchNome = !this.filtroNome || 
        pesquisador.nome.toLowerCase().includes(this.filtroNome.toLowerCase());
      
      const matchCpf = !this.filtroCpf || 
        pesquisador.cpf.includes(this.filtroCpf);
      
      const matchPesquisador = !this.filtroPesquisador || 
        pesquisador[this.filtroPesquisador] === true;

      return matchNome && matchCpf && matchPesquisador;
    });
  }

  limparFiltros() {
    this.filtroNome = '';
    this.filtroCpf = '';
    this.filtroPesquisador = '';
    this.pesquisadoresFiltrados = [...this.pesquisadores];
  }

  openModal(content: any, limparform=false): void {
    if(limparform){
      this.pesquisadorSelecionado = null;
      this.cadastroForm.patchValue({
        id: "",
        nomeCompleto: "",
        cpf: "",
        email: "",
        telefone: "",
        endereco: "",
        pesquisadorBrasil: false,
        pesquisadorItalia: false,
        pesquisadorOutros: false,
        outrosPaises:''
      });
    }
     
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  onSubmit() {
    if (this.cadastroForm.valid) {
      const formData = this.cadastroForm.value;
      if (this.outrosPaises) {
        formData.outrosPaises = this.outrosPaises;
      }

      let dados = {        
        "NOME": formData.nomeCompleto,
        "CPF": formData.cpf,
        "EMAIL": formData.email,
        "TELEFONE": formData.telefone,
        "ENDERECO": formData.endereco,
        "PESQUISADOR_BRASIL": formData.pesquisadorBrasil ? true: false,
        "PESQUISADOR_ITALIA": formData.pesquisadorItalia ? true : false,
        "PESQUISADOR_OUTROS": formData.pesquisadorOutros ? true: false,
        "OUTROS_OBS": formData.outrosPaises,
      }

      if (this.pesquisadorSelecionado != null) {
        let url = API + "Usuario/Usuario/pesquisador";
        dados["ID_USUARIO_PESQUISADOR"] = this.pesquisadorSelecionado.iD_USUARIO_PESQUISADOR;
        dados["ID_USUARIO"] = this.pesquisadorSelecionado.iD_USUARIO;
        // Atualizar pesquisador existente
        this.ajaxService.post(url, dados).subscribe({
          next: (response) => {
            this.carregarPesquisadores();
            this.modalRef.dismiss();
            this.cadastroForm.reset();
          },
          error: (error) => {
            console.error('Erro ao atualizar pesquisador:', error);
          }
        });
      } else {
        let url = API + "Usuario/Usuario/pesquisador";
        // Criar novo pesquisador
        this.ajaxService.post(url, dados).subscribe({
          next: (response) => {
            this.carregarPesquisadores();
            this.modalRef.dismiss();
            this.cadastroForm.reset();
          },
          error: (error) => {
            console.error('Erro ao criar pesquisador:', error);
          }
        });
      }
    }
  }

  editarPesquisador(pesquisador: any) {
    debugger
    this.pesquisadorSelecionado = pesquisador;
    this.cadastroForm.patchValue({
      id: pesquisador.id,
      nomeCompleto: pesquisador.nome,
      cpf: pesquisador.cpf,
      email: pesquisador.email,
      telefone: pesquisador.telefone,
      endereco: pesquisador.endereco,
      pesquisadorBrasil: pesquisador.pesquisadoR_BRASIL,
      pesquisadorItalia: pesquisador.pesquisadoR_ITALIA,
      pesquisadorOutros: pesquisador.pesquisadoR_OUTROS
    });

    this.outrosPaises = pesquisador.outroS_OBS;
  }

  excluirPesquisador(id: number) {
    if (confirm('Tem certeza que deseja excluir este pesquisador?')) {
      this.ajaxService.delete(`Usuario/Usuario/pesquisador/${id}`).subscribe({
        next: () => {
          this.carregarPesquisadores();
        },
        error: (error) => {
          console.error('Erro ao excluir pesquisador:', error);
        }
      });
    }
  }
} 